window.addEventListener('load', ()=>{
	$('#provincePageTimes').change(function(event) {
		/* Act on the event */
		var el = $(this),
			provincesContainer = $('[js-times-select]'),
			provincesDataDays = el.find(':selected').attr('data-days');
			provincesData = el.val();
		el.prop("selected", "selected");
		provincesContainer.find('[data-times]').empty().text(provincesDataDays);
		provincesContainer.find('[data-option]').empty().text(provincesData);
	});
});